export default "__VITE_ASSET__BvVe5uMU__"